import { AxiosError } from "axios"
import { ErrorType } from "@/shared/types"

const statusMessages: Record<number, string> = {
    400: "Параметры фильтра заданы неверно",
    401: "Сессия истекла, войдите заново",
    403: "Нет доступа к аналитике лояльности",
    404: "Данные аналитики лояльности не найдены",
    422: "Период или объём данных превышает лимит. Сузьте период и повторите попытку",
    502: "Сервис аналитики лояльности временно недоступен",
    503: "Сервис аналитики лояльности временно недоступен",
    504: "Сервис аналитики лояльности не ответил вовремя",
}

export const getLoyaltyAnalyticsErrorMessage = (error: unknown): string => {
    const knownError = error as AxiosError<ErrorType>
    const status = knownError.response?.status

    if (status && statusMessages[status]) return statusMessages[status]
    if (knownError.code === "ECONNABORTED") {
        return "Сервис не ответил вовремя. Повторите попытку"
    }
    if (!knownError.response) {
        return "Не удалось связаться с сервером. Проверьте соединение и повторите попытку"
    }

    return knownError.response.data?.message || "Произошла непредвиденная ошибка"
}
